import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Textarea({
  className,
  ...props
}: ComponentProps<'textarea'>): JSX.Element {
  return (
    <textarea
      data-slot='textarea'
      className={cn(
        'placeholder:text-[#bfbfbf] dark:aria-invalid:ring-destructive/40 dark:bg-input/30 flex field-sizing-content w-full bg-transparent transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50',
        'min-h-30 border resize-none text-(length:--text-md) leading-[130%]',
        'px-4 py-3 rounded-md border-[#ececec] hover:border-[#cdcdcd] focus-visible:border-blueBonnet-500 aria-invalid:border-desire-500',
        className,
      )}
      {...props}
    />
  );
}
